import DialogContent from '@mui/material/DialogContent'
import Modal from '@mui/material/Modal'
import { useCallback, useContext, useEffect, useMemo } from 'react'

import ModalLayout from '@/components/common/ModalLayout'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import useTrans from '@/hooks/useTrans'

import { AssetWithdrawalContext } from '../context'
import WithdrawalConnectWallet from '../WithdrawalConnectWallet'
import WithdrawalForm from '../WithdrawalForm'

const classesDialog = { root: 'outline-none p-0 h-full' }
const Container = () => {
  const trans = useTrans()
  const { publicKey } = useNemoWallet()
  const { selectedToken, setSelectedToken, submitWithdrawByRenecNetwork } = useContext(AssetWithdrawalContext)
  const isModalOpened = Boolean(selectedToken)

  useEffect(() => {
    if (!isModalOpened) { // Reset data
      setSelectedToken(null)
    }
  }, [setSelectedToken, isModalOpened])

  const modalTitle = useMemo(() => {
    return trans.asset_withdrawal.withdrawing(selectedToken?.displaySymbol ?? '')
  }, [trans, selectedToken])

  const handleCloseModal = useCallback(() => {
    setSelectedToken(null)
  }, [setSelectedToken])

  return (
    <Modal open={isModalOpened} onClose={handleCloseModal}>
      <DialogContent classes={classesDialog}>
        <ModalLayout
          title={modalTitle}
          onClose={handleCloseModal}
          isDisplayBtnClose={false}
          footer={trans.common.powered_by_remitano}
        >
          {publicKey
            ? <WithdrawalForm onSubmit={submitWithdrawByRenecNetwork} />
            : <WithdrawalConnectWallet />
          }
        </ModalLayout>
      </DialogContent>
    </Modal>
  )
}

export default Container
